var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00164 4.21937L5.43411 3L19.4341 11V12.7365L5.43411 20.7365L4 19.5216L5.25454 16.1275L5.87826 14.5061L6.49384 12.8682H15.0017V10.8682H6.49496L4.00164 4.21937Z",
    fill: "#8C8A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon1);
export default __webpack_public_path__ + "static/media/send_icon1.7117fe5602fa1608642a1b604cf0149a.svg";
export { ForwardRef as ReactComponent };